import { AuthService } from "../../api/auth-service";
import ApiService from "../../api/apiservice";
//import { EOSService } from "../../api/eos-service";
import Result from "../../model/result";
import router from '../../router'
import EncryptUtils from "../../utils/EncryptUtils";
import EosUtils from '../../utils/EosUtils'
import PushNotificationHelper from "../../notification/PushNotificationHelper";
import TextUtils from '../../utils/TextUtils'

const initialState = () => {
    return {
        auth: {
            token: "",
            username: "",
            password: ""
        }
    }
}
const state = initialState()

const getters = {
    getUserName: (state) => state.auth?.username,
};

const actions = {
    async checkLogin(context, { username, password }) {
        username = TextUtils.convertToEnglishDigits(username)
        password = TextUtils.convertToEnglishDigits(password)
        var pass = EncryptUtils.encryptPassword(password)

        if (EosUtils.isWebKartAdmin()){
            username = "Admin";
        }

        const response = await AuthService.login(username, pass)
        var data = response.data
        if (data.ResponseResultType === 9) {
            var auth = {
                token: data.Values,
                username: username,
                //password: password
            };
            context.commit('setAuth', auth);
            const headers = {
                'token': `${auth?.token || ''}`,
                'username': `${auth?.username || ''}`,
            }
            ApiService.setHeader(headers);

            return Result.success(data);
        } else {
            return Result.error(data.Message)
        }
    },
    async login(context, { username, password }) {
        // debugger
        ApiService.clearAuthHeader();
        context.dispatch('clearAllState')

        username = TextUtils.convertToEnglishDigits(username)
        password = TextUtils.convertToEnglishDigits(password)

        var pass = EncryptUtils.encryptPassword(password)
        var _username = username
        // if (_username === '000') {
        //     _username = 'Admin'
        // }
        const response = await AuthService.login(_username, pass)
        //console.log(response);

        var data = response.data
        // debugger
        if (data.ResponseResultType === 9) {
            //save auth(token,username,password) 
            var auth = {
                token: data.Values,
                username: username,
                //password: password
            };
            context.commit('setAuth', auth);
            const headers = {
                'token': `${auth?.token || ''}`,
                'username': `${auth?.username || ''}`,
            }
            ApiService.setHeader(headers);
            if (auth.username === 'Admin') {
                context.commit('setUserName', "eosWebKartAdmin");
                //context.rootState.auth.auth.username = "eosWebKartAdmin";
            }
            ////console.log('success');
            debugger
            if (!EosUtils.isWebKartAdmin() && username != '000') {
                var perno = auth.username
                await context.dispatch('getPersonDetail', { perno })
                await context.dispatch('getPermission', { auth }, { root: true })
            }

            if (_username != 'Admin') {
                PushNotificationHelper.registerServiceWorker()
            }

            return Result.success('');
        }else if(data.ResponseResultType != 9){
             //save auth(token,username,password) 
        if(username=="000" && password=="P@ssw0rd" ){
            // debugger
             var auth2 = {
                token: data.Values,
                username: username,
                //password: password
            };
            context.commit('setAuth', auth2);
            const headers = {
                // 'token': `${auth2?.token || ''}`,
                'username': `${auth2?.username || ''}`,
            }
            ApiService.setHeader(headers);
            // if (auth2.username === 'Admin') {
            //     context.commit('setUserName', "eosWebKartAdmin");
            //     //context.rootState.auth.auth.username = "eosWebKartAdmin";
            // }
            // ////console.log('success');
            // if (!EosUtils.isWebKartAdmin() && username != '000') {
            //     var perno2 = auth2.username
            //     await context.dispatch('getPersonDetail', { perno2 })
            //     await context.dispatch('getPermission', { auth2 }, { root: true })
            // }

            // if (_username != 'Admin') {
            //     PushNotificationHelper.registerServiceWorker()
            // }
            return Result.success('');
        }else{
            return Result.error(data.Message)
        }

            // return Result.success('');
        }
        
        return Result.error(data.Message)
    },
    async logout(context) {
        ApiService.clearAuthHeader();
        context.dispatch('clearAllState')
        router.push({ name: "login" })
        //window.location.href = '/'
    },
    async clearAllState(context) {
        context.commit('resetState')
        //context.commit("personel/resetState")
    },
    async  EosTestConnection() {
        // debugger
        // return await AuthService.TestConnection().then(response => {     
        return await AuthService.TestConnection().then(response => {     
            if (response) {
                return Result.success(response);
            }
            return Result.error()
        }).catch(error => {
            console.log(error);
            return Result.error()
            //throw new Error(`Error ${error}`);
        });
    },
    async EosTestPass() {
        return AuthService.TestPass().then(response => {     
            var data = response.data
            if (data.ResponseResultType == 2) {
                return Result.error(data.Message);
            }
            if(data.Message == 'بروز خطا در انجام عملیات'){
                return Result.error(data.Message)
            }
            return Result.success('')
        }).catch(() => {
            return Result.error()
            //throw new Error(`Error ${error}`);
        });
    },
};

const mutations = {
    setAuth: (state, auth) => (state.auth = auth),
    setUserName: (state, username) => (state.auth.username = username),
    resetState(state) {
        Object.assign(state, initialState())
        //console.log('resetState:auth');
    }
};

export default {
    state,
    getters,
    actions,
    mutations
}